export default __webpack_public_path__ + "static/media/berry.4cb6bfd9.png";